import React, { FC } from 'react'
import classNames from 'classnames'
import { CardElement } from '@stripe/react-stripe-js'
import { StyledStripeInput } from '.'

type Props = {
  ariaLabel?: string;
  className?: string;
  isError?: boolean;
  isDisabled?: boolean;
  [x: string]: any;
}

const StripeInput: FC<Props> = ({
  ariaLabel, className, isError, isDisabled, ...props
}) => {
  const CARD_ELEMENT_OPTIONS = {
    disabled: isDisabled,
    style: {
      invalid: {
        color: '#B93619',
        iconColor: '#B93619'
      }
    }
  }

  return (
    <StyledStripeInput className={classNames('stripe-input', className)} isError={isError}>
      <CardElement aria-label={ariaLabel} options={CARD_ELEMENT_OPTIONS} {...props} />
    </StyledStripeInput>
  )
}

export default StripeInput
